import { useId, type SVGProps } from 'react';

export const GoogleWalletMarkIcon = (props: SVGProps<SVGSVGElement>) => {
    const id = useId();
    const gradientId = `${id}-gradient`;
    return (
        <svg width="32" height="30" viewBox="0 0 32 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M31.4182 10.1224H0V5.19554C0 2.52089 2.30592 0.268555 5.04419 0.268555H26.374C29.1123 0.268555 31.4182 2.52089 31.4182 5.19554V10.1224Z"
                fill="#34A853"
            />
            <path
                d="M31.4182 14.668H0V9.43168C0 6.58912 2.30592 4.19531 5.04419 4.19531H26.374C29.1123 4.19531 31.4182 6.58912 31.4182 9.43168V14.668Z"
                fill="#FBBC04"
            />
            <path
                d="M31.4182 19.0323H0V13.7959C0 10.9534 2.30592 8.55957 5.04419 8.55957H26.374C29.1123 8.55957 31.4182 10.9534 31.4182 13.7959V19.0323Z"
                fill="#EA4335"
            />
            <path
                d="M0 11.388L19.9412 15.8927C22.2367 16.4557 24.819 15.8927 26.6839 14.4849L31.4182 11.1064V21.6642C31.4182 24.3388 29.1228 26.4504 26.397 26.4504H5.02115C2.29536 26.4504 0 24.3388 0 21.6642V11.388Z"
                fill={`url(#${gradientId})`}
            />
            <defs>
                <linearGradient
                    id={gradientId}
                    x1="14.2118"
                    y1="19.0714"
                    x2="-1.93545"
                    y2="37.9903"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#4285F4" />
                    <stop offset="1" stopColor="#1B74E8" />
                </linearGradient>
            </defs>
        </svg>
    );
};
